import type { ModalProps } from 'antd';
import {
  render as reactRender,
  unmount as reactUnmount,
} from 'rc-util/lib/React/render';
import React from 'react';
import BaseDrawer, { BaseDrawerProps } from './BaseDrawer';
import BaseModal, { BaseModalProps } from './BaseModal';
import MsgModal, { MsgModalProps } from './MsgModal';

const destroyFns: Array<() => void> = [];
function show<T extends ModalProps>(config: T, Modal: React.FunctionComponent) {
  const container = document.createDocumentFragment();
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  let currentConfig = { ...config, close, open: true } as any;

  function destroy(...args: any[]) {
    const triggerCancel = args.some((param) => param && param.triggerCancel);
    if (config.onCancel && triggerCancel) {
      // @ts-ignore
      config.onCancel(() => {}, ...args.slice(1));
    }
    for (let i = 0; i < destroyFns.length; i++) {
      const fn = destroyFns[i];
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }

    reactUnmount(container);
  }

  function render(props: any) {
    /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */
    setTimeout(() => {
      reactRender(<Modal {...props} />, container);
    });
  }

  function close(...args: any[]) {
    currentConfig = {
      ...currentConfig,
      open: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }

        // @ts-ignore
        destroy.apply(this, args);
      },
    };
    render(currentConfig);
  }

  function update(configUpdate: any) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = {
        ...currentConfig,
        ...configUpdate,
      };
    }
    render(currentConfig);
  }

  render(currentConfig);

  destroyFns.push(close);

  return {
    destroy: close,
    update,
  };
}

export const showMsgModal = (config: MsgModalProps) =>
  show<MsgModalProps>(config, MsgModal);

export const showInfoModal = (config: BaseModalProps) =>
  show<BaseModalProps>(config, BaseModal);

export const showBaseDrawer = (config: BaseDrawerProps) =>
  show<BaseDrawerProps>(config, BaseDrawer);
